<template>
	<!-- qc小组 -->
	<el-dialog :visible.sync="dialogVisible" top="5vh" :width="outerWidth" :before-close="cancelScaql">
		<div>
			<table border="1" cellspacing="0" align="center">
				<caption style="font-size: 18px;font-weight: bold;margin-bottom: 10px;">个人信息</caption>
				<tr>
					<td>姓名</td>
					<td>
						<el-input v-model="form.name"></el-input>
					</td>
					<td rowspan="6">个人证件照</td>
					<td rowspan="6">
						<span v-if="!imgUrl">请上传个人证件照</br>（一寸照片）</span>
						<el-image v-else style="width: 100px; height: 100px" :src="imgUrl"
							:preview-src-list="[imgUrl,]">
						</el-image>
						</br>
						<el-upload v-if="status ==''" ref="upload" style="display: inline-block;"
							accept=".png,.jpg,.ipeg" action="" :http-request="httpRequest" :on-remove="handleRemove"
							:before-upload="beforeUpload" :show-file-list="false">
							<a style="cursor: pointer;">点击上传</a>
						</el-upload>
					</td>
				</tr>
				<tr>
					<td>出生年月</td>
					<td>
						<el-date-picker v-model="form.birthdate" value-format="yyyy-MM-dd" type="date"
							placeholder="选择日期">
						</el-date-picker>
					</td>
				</tr>
				<tr>
					<td>民族</td>
					<td>
						<el-input v-model="form.nation"></el-input>
					</td>
				</tr>
				<tr>
					<td>性别</td>
					<td>
						<el-select style="width: 100%;" v-model="form.sex" placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</td>
				</tr>
				<tr>
					<td>政治面貌</td>
					<td>
						<el-input v-model="form.political"></el-input>
					</td>
				</tr>
				<tr>
					<td>身份证号</td>
					<td>
						<el-input v-model="form.idcard"></el-input>
					</td>
				</tr>
				<tr>
					<td>参与工作时间</td>
					<td>
						<el-date-picker v-model="form.work_time" value-format="yyyy-MM-dd" type="date"
							placeholder="选择日期">
						</el-date-picker>
					</td>
					<td>手机</td>
					<td>
						<el-input v-model="form.cellphone"></el-input>
					</td>
				</tr>
				<tr>
					<td>邮箱</td>
					<td>
						<el-input v-model="form.email"></el-input>
					</td>
					<td>通讯地址</td>
					<td>
						<el-input v-model="form.sms_address"></el-input>
					</td>
				</tr>
				<tr style="border-top: 3px solid #ccc;border-left: 3px solid #ccc;border-right: 3px solid #ccc;">
					<td>工作单位</td>
					<td>
						<el-input v-model="form.work_unit"></el-input>
					</td>
					<td>岗位</td>
					<td>
						<el-input v-model="form.position"></el-input>
					</td>
				</tr>
				<tr style="border-bottom: 3px solid #ccc;border-left: 3px solid #ccc;border-right: 3px solid #ccc;">
					<td>职务</td>
					<td>
						<el-input v-model="form.post"></el-input>
					</td>
					<td>职称</td>
					<td>
						<el-input v-model="form.title"></el-input>
					</td>
				</tr>
				<tr style="border-left: 3px solid #ccc;border-right: 3px solid #ccc;">
					<td>毕业院校（第一学历）</td>
					<td>
						<el-input v-model="form.f_school"></el-input>
					</td>
					<td>专业</td>
					<td>
						<el-input v-model="form.f_major"></el-input>
					</td>
				</tr>
				<tr style="border-bottom: 3px solid #ccc;border-left: 3px solid #ccc;border-right: 3px solid #ccc;">
					<td>学历</td>
					<td>
						<el-input v-model="form.f_education"></el-input>
					</td>
					<td>毕业时间</td>
					<td>
						<el-date-picker v-model="form.f_graduate_date" value-format="yyyy-MM-dd" type="date"
							placeholder="选择日期">
						</el-date-picker>
					</td>
				</tr>
				<tr style="border-left: 3px solid #ccc;border-right: 3px solid #ccc;">
					<td>毕业院校（最高学历）</td>
					<td>
						<el-input v-model="form.school" placeholder="（非必填）"></el-input>
					</td>
					<td>专业</td>
					<td>
						<el-input v-model="form.major"></el-input>
					</td>
				</tr>
				<tr style="border-bottom: 3px solid #ccc;border-left: 3px solid #ccc;border-right: 3px solid #ccc;">
					<td>学历</td>
					<td>
						<el-input v-model="form.education"></el-input>
					</td>
					<td>毕业时间</td>
					<td>
						<el-date-picker v-model="form.graduate_date" value-format="yyyy-MM-dd" type="date"
							placeholder="选择日期">
						</el-date-picker>
					</td>
				</tr>
				<tr style="border-left: 3px solid #ccc;border-right: 3px solid #ccc;">
					<td>职业注册资格</td>
					<td>
						<el-input v-model="form.reg_qualification" placeholder="（非必填）"></el-input>
					</td>
					<td>注册专业</td>
					<td>
						<el-input v-model="form.reg_major"></el-input>
					</td>
				</tr>
				<tr style="border-bottom: 3px solid #ccc;border-left: 3px solid #ccc;border-right: 3px solid #ccc;">
					<td>证书编号</td>
					<td>
						<el-input v-model="form.cer_num"></el-input>
					</td>
					<td>注册时间</td>
					<td>
						<el-date-picker v-model="form.reg_time" value-format="yyyy-MM-dd" type="date"
							placeholder="选择日期">
						</el-date-picker>
					</td>
				</tr>
				<tr>
					<td colspan="4">
						<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;工作经历（多个）</span>
						<el-button style="margin-left: 620px;" v-if="status ==''" @click="addTable">新增</el-button>
					</td>
				</tr>
				<tr>
					<td>起止时间</td>

					<td colspan="2">主要工作经历</td>
					<td>动作</td>
				</tr>
				<tr v-for="(item,index) in editTableList" :key="index">
					<td>
						<el-date-picker v-model="startEndTime[index]" value-format="yyyy-MM-dd" type="daterange"
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</td>
					<td colspan="2">
						<el-input type="textarea" v-model="experience[index]">
						</el-input>
					</td>
					<td>
						<!-- <span style="cursor: pointer;">
							编辑
						</span> -->
						<span v-if="status ==''" @click="deleteTable(index)" style="cursor: pointer;">
							删除
						</span>
					</td>
				</tr>
			</table>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button v-if="status =='check'" @click="cancelScaql">关 闭</el-button>
			<el-button v-if="status ==''" @click="cancelScaql">取 消</el-button>
			<el-button v-if="status ==''" type="primary" @click="submitForm">提 交</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import {
		client
	} from '@/libs/oss.js'
	export default {
		data() {
			return {
				dialogVisible: false,
				form: {
					name: '',
					id_photo: "",
					birthdate: "",
					nation: "",
					sex: "",
					political: "",
					idcard: "",
					work_time: "",
					cellphone: "",
					email: '',
					sms_address: '',
					work_unit: '',
					position: '',
					post: '',
					title: '',
					f_school: '',
					f_major: '',
					f_education: '',
					f_graduate_date: '',
					experience: []
					// 非必填
				},
				editTableList: [],
				options: [{
					value: '1',
					label: '男'
				}, {
					value: '2',
					label: '女'
				}],
				imgUrl: '',
				startEndTime: [],
				experience: [],
				// 基本信息表单
				formName: {
					name: '姓名',
					id_photo: "个人证件照",
					birthdate: "出生年月",
					nation: "民族",
					sex: "性别",
					political: "政治面貌",
					idcard: "身份证号",
					work_time: "参与工作时间",
					cellphone: "手机",
					email: '邮箱',
					sms_address: '通讯地址',
					work_unit: '工作单位',
					position: '岗位',
					post: '职务',
					title: '职称',
					f_school: '毕业院校（第一学历）',
					f_major: '专业',
					f_education: '学历',
					f_graduate_date: '毕业时间',
					experience: '工作经历'
				},
			}
		},
		props: {
			outerWidth: {
				type: String,
				default: '1000px'
			},
			status: {
				type: String,
				default: ''
			}
		},
		methods: {
			// 表单整合
			submitForm() {
				// 表单内部提交
				this.startEndTime.forEach((item, index) => {
					const newObj = {}
					newObj.startEndTime = item
					newObj.experience = this.experience[index]
					this.form.experience[index] = newObj
				})
				const params = {
					...this.form
				}
				if (this.requireSubmit(params, this.formName)) {
					return
				}
				this.$emit('finshTable', [this.form, this.chooseIndex])
				this.handleClose()
			},
			addTable() {
				this.editTableList.push({})
			},
			deleteTable(index) {
				this.editTableList.splice(index, 1)
				this.form.experience.splice(index, 1)
				this.startEndTime.splice(index, 1)
				this.experience.splice(index, 1)
			},
			openDialog(e, value) {
				this.chooseIndex = e
				this.dialogVisible = true
				if (value) {
					this.form = {
						...value
					}
					this.imgUrl = value.id_photo
					if (value.experience != undefined) {
						value.experience.forEach((item, index) => {
							this.editTableList.push({})
							this.startEndTime[index] = item.startEndTime
							this.experience[index] = item.experience
						})
					}
				}
			},
			// 获取必填警示
			requireSubmit(params, nameList) {
				//如果数据是对象形式
				let upString = []
				Object.keys(params).forEach((item, index) => {
					if (params[item] == '' || params[item] == undefined || params[item] == null) {
						if (nameList[item]) {
							upString.push(item)
						}
					}
				})
				if (!upString.length) {
					return false
				} else {
					this.$message.error(`${nameList[upString[0]]}未填写`)
					return true
				}
				// 如果数据是数组形式
			},
			// 取消
			cancelScaql() {
				this.$emit('cancel')
				this.handleClose()
			},
			handleClose() {
				this.dialogVisible = false
				// 清理缓存
				this.form = {
					name: '',
					id_photo: "",
					birthdate: "",
					nation: "",
					sex: "",
					political: "",
					idcard: "",
					work_time: "",
					cellphone: "",
					email: '',
					sms_address: '',
					work_unit: '',
					position: '',
					post: '',
					title: '',
					f_school: '',
					f_major: '',
					f_education: '',
					f_graduate_date: '',
					experience: []
				}
				this.startEndTime = []
				this.experience = []
				this.editTableList = []
				this.imgUrl = ''
			},
			// 移除
			handleRemove(e, fileList) {
				this.fileList = fileList;
			},
			//上传前
			beforeUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 20;
				if (!isLt2M) {
					this.$message.error('文件大小不能超过 20M !');
				}
				return isLt2M;
			},
			httpRequest({
				file
			}) {
				const fileName = `项目申报/qc小组/${Date.parse(new Date())}/${file.name}`; //定义唯一的文件名
				client.put(fileName, file).then(({
					res,
					url,
					name
				}) => {
					if (res && res.status == 200) {
						this.$message({
							message: '上传成功',
							type: 'success'
						});
						// console.log(`阿里云OSS上传文件成功回调`, res, url, name);
						this.imgUrl = url
						this.form.id_photo = url
						// this.fileList.push({ //回显文件name用
						// 	url: url,
						// 	id: fileName,
						// 	name: file.name,
						// })
					}
				}).catch((err) => {
					console.log(`阿里云OSS上传失败回调`, err);
				});
			},
		}
	}
</script>

<style scoped>
	>>>.el-input__inner {
		border: 1px solid #fff;
	}

	/*表格样式*/
	table {
		width: 90%;
		background: #ccc;
		margin: 10px auto;
		border-collapse: collapse;
		/*border-collapse:collapse合并内外边距
	(去除表格单元格默认的2个像素内外边距*/
	}

	th,
	td {
		min-width: 200px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		border: 1px solid #ccc;
	}

	th {
		background: #eee;
		font-weight: normal;
	}

	tr {
		background: #fff;
	}

	/* tr:hover {
		background: rgb(232, 237, 250);
	} */

	td a {
		color: #06f;
		text-decoration: none;
	}

	td a:hover {
		color: #06f;
		text-decoration: underline;
	}
</style>
